import type { PillStyles } from "@smartsuite/react-ui/lib/components/widgets/Pill/Pill";
import { Colors, TextColorNames } from "@smartsuite/types";

export const linkedRecordPillStyles: PillStyles = {
  borderDefault: Colors.linkedRecordFieldColor,
  backgroundDefault: Colors.linkedRecordFieldColor,
  backgroundHover: Colors.linkedRecordFieldHoverColor,
  borderHover: Colors.linkedRecordFieldHoverColor,
  removeButtonColor: TextColorNames.secondary,
  removeButtonColorHover: TextColorNames.primary,
  borderRadius: 5,
};
